export default function (state, data) {
    state.items = [];
    state.time = new Date().getTime() + (60 * 60 * 1000);
    if (data && data.Items) {
        data.Items.forEach(i => {
            state.items.push({
                value: i.Id,
                label: i.Name,
                direction: 1 + i.InOut,
                category: i.PaymentTypeCategoryId,
                type: i.PaymentTypeId,
                operationType: i.OperationType,
                paymentFor: i.PaymentFor,
                bonuses: i.IsBonusesPayment,
            });
        });
    } else {
        state.time = 0;
    }
    state.loading = false;
    state.cbs.forEach(i => {
        i(state);
    });
    state.cbs = [];
}